import { useEffect, useState } from "react";
import { CreditCard, Banknote, DollarSign } from "lucide-react";
import { getConfig } from "../lib/api";
import { Reveal } from "./Reveal";

export const PaymentsSection = () => {
    const [payments, setPayments] = useState(null);

    useEffect(() => {
        getConfig().then((c) => setPayments(c.payments)).catch(() => {});
    }, []);

    const items = [
        {
            icon: CreditCard,
            title: "Credit / debit card",
            desc: "Secure online payment via Stripe — pay when you book, or after class.",
            testid: "payment-card",
        },
        {
            icon: DollarSign,
            title: "CashApp",
            desc: payments?.cashapp ? `Send to ${payments.cashapp}` : "Handle shared at booking.",
            testid: "payment-cashapp",
        },
        {
            icon: Banknote,
            title: "Cash",
            desc: "Pay in person after your session. Receipt provided.",
            testid: "payment-cash",
        },
    ];

    return (
        <section id="payments" data-testid="payments-section" className="border-t border-ink/10 py-20 md:py-28 bg-white">
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <Reveal>
                    <p className="flex items-center gap-3 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/50">
                        <span className="h-px w-10 bg-worx inline-block" /> Ways to pay
                    </p>
                    <h2 className="mt-6 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl">
                        However works for you.
                    </h2>
                </Reveal>
                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
                    {items.map((it, i) => (
                        <Reveal key={it.title} delay={i * 0.06}>
                            <div data-testid={it.testid} className="bg-white p-8 h-full hover:bg-paper transition-colors duration-200">
                                <it.icon size={26} className="text-worx" />
                                <h3 className="mt-4 font-display font-medium text-xl">{it.title}</h3>
                                <p className="mt-2 text-sm text-ink/60 leading-relaxed">{it.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
